<template>
  <section class="container-fluid login_page_section login-img">
    <div class="row align-items-center">
      <div class="col-md-6 login_left_section">
        <div class="text-center">
          <img src="../../public/assets/Images/Signup2.png" alt="" />
        </div>
      </div>
      <div class="col-md-6 login_right_section_signup">
        <div class="logo_section mx-3 mt-n1">
          <img src="../assets/Images/logo.png" alt="" width=""/>
        </div>
        <div style="clear: both"></div>
        <div class="row justify-content-center responsive"
          style="padding-right: var(--bs-gutter-x, 0.75rem); padding-left: var(--bs-gutter-x, 0.75rem);">
          <div class="col-xl-8 col-lg-10 col-md-11">
            <div class="login_page_heading">
              <h3 class="font-weight-800">Create your PMaps Account Now !
              </h3>
              <p>Innovative Assessments for Efficient Recruitment</p>
            </div>
            <form action="">
              <div class="row my-4 mb-3">
                <div class="col-12 col-xl-6 col-sm-12 space">
                  <label class="input-hero">
                    <input class="input_area" required v-model="firstName" />
                    <span class="input-name" :class="{ 'input-focusedName': isFocused }"> First Name </span>
                  </label>
                </div>
                <div class="col-12 col-xl-6 col-sm-12 space">
                  <label class="input-hero">
                    <input class="input_area" required v-model="lastName" />
                    <span class="input-name" :class="{ 'input-focusedName': isFocused }"> Last Name </span>
                  </label>
                </div>
              </div>
              <div class="form-group mt-3">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="text" required v-model="companyName" />
                    <span class="input-name">Company Name</span>
                  </label>
                </div>
              </div>
              <div class="form-group mt-4">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="email" required v-model="Email" />
                    <span class="input-name">Work Email</span>
                  </label>
                </div>
              </div>
              <!-- <div class="form-group mt-4">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <input class="input_area" type="tel" required v-model="Phone" />
                    <span class="input-name">Phone Number</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-group mb-3">
                  <label class="input-hero">
                    <select class="form-select input_area select_ca" v-model="countryName" required>
                      <option disabled selected>Select Preferred Country</option>
                      <option v-for="item in GetLocationData.object.data" :key="item" :value="item.iso2">
                        {{ item.name }}
                      </option>
                    </select>
                    <span class="input-name">Country</span>
                  </label>
                </div>
              </div> -->
              <div class="form-group mt-4">
                <div class="form-group mb-3 position-relative">
                  <span class="input-name" :class="{ 'input-focused': isFocused }">Phone Number</span>
                  <vue-tel-input v-model="phoneNumber" :defaultCountry="defaultCountry" :enabledFlags="true"
                    :enabledCountryCode="true" :inputClasses="'form-control'" :wrapperClasses="'phone-input'"
                    :validCharactersOnly="true" :disabledFetchingCountry="true" :disabled="false" style="width: 100%"
                    :dropdownOptions="dropdownOptions" @validate="onValidate" @country-changed="onCountryChange"
                    @input="onInput" @blur="handleBlur" @focus="handleFocus" mode="international">
                  </vue-tel-input>


                  <!-- Validation message -->
                  <div v-if="!isValid && phoneNumber && phoneNumber.length > 4"
                    class="invalid-feedback d-block mt-1 small">
                    Phone number is not valid for {{ countryName }}
                  </div>
                </div>
              </div>
                           
              <div v-if="this.captchaIsVisible == 'true'" class="pt-2">
                <form>
                  <div id="recaptcha-container"></div>
                </form>
              </div>

              <div style="font-size: 15px; display: flex; align-items: center; margin-top: 5%;">
                <input type="checkbox" name="" id="" style="margin-right: 2%; " v-model="privacy">
                <span style="color: rgb(92, 92, 92);">By signing up you agree to PMaps's Terms and <a
                    href="https://pmapstest.com/privacy-policy/" target="_blank">Privacy Policy </a></span>
              </div>

              <div class="mt-4 login_button_area mb-6">
                <div class="row">
                  <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <router-link :to="{ name: 'Login' }" class="btn btn-primary2 me-3 mb-3" type="submit" style="width: 100%;">
                  Back to Login
                </router-link>
                 </div>  -->
                  <div class="col-12 ">
                    <!-- Separate function for disabled  -->
                    <button class="btn btn-primary" @click="createAccount" type="button"
                      style="width: 100%; font-size: 17px !important;" :disabled="ValidateData()">
                      Create Account
                    </button>
                  </div>
                </div>
                <div class="float-end mt-3 mb-5">Already have an account?
                  <router-link :to="{ name: 'Login' }" type="submit">
                    Sign in
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
// import { validatePhoneNumber } from "@/utils";
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'


export default {
  name: "Signup",
  components: {
    VueTelInput
  },
  data() {
    return {
      emailError: "",
      GetLocationData: {
        object: {
          data: [],
        },
      },
      companyName: "",
      firstName: "",
      lastName: "",
      countryName: "",
      countryISO2: '',
      Email: "",
      lat: "",
      lng: "",
      error: "",
      country: "",
      privacy: false,
      phoneNumber: '',
      isValid: true,
      selectedCountry: '',
      defaultCountry: 'IN',
      currentDialCode: '',
      previousDialCode: '',
      hasBlurred: false,
      isFocused: false,
      dropdownOptions: {
        showDialCode: true,
        showFlags: true,
        showCode: true,
        tabindex: 0,
        showDialCodeInList: true,
        
      },
      plancode: "",
      PhoneError: "",
      testId: this.$route.query.LibraryId,
      siteKey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY, // Replace with your reCAPTCHA v2 site key
      captchaVerified: false,
      recaptchaToken: '',
      captchaIsVisible: '',
            
    };
  },
  async created() {
    this.GetLocationData = await this.getlocation();
    
  },
  async mounted() {
    await this.fetchLocation();
    const canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    canonicalLink.href = 'app-assess.pmapstest.com';
    document.head.appendChild(canonicalLink);
    this.captchaIsVisible = window.config?.CAPTCHA_STATUS;
    if(this.captchaIsVisible == 'false'){
        this.captchaVerified = true;
    }
    if(this.captchaIsVisible == 'true'){
      const interval = setInterval(() => {
        if (window.grecaptcha) {
          this.renderRecaptcha()
          clearInterval(interval)
        }
      }, 300)
    }

  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

  },
  methods: {
    ...mapActions(["ShowWarningMessage", "billingSignupV2", "getlocation"]),


    ValidateData() {
      return this.privacy == false || this.Email == '' || this.phoneNumber == '' || this.companyName == '' || this.firstName == '' || this.lastName == '' || this.captchaVerified == false ;
    },
    validatePhoneNumber() {

      if (!this.isValid) {
        return this.ShowWarningMessage("Enter valid phone number");

      } else {
        return true;
      }

    },
    handleFocus() {
      this.isFocused = true
    },
    onValidate({ valid, country }) {  
        this.isValid = valid
        if (country) {
          this.selectedCountry = country.iso2
          this.countryName = country.name;
        }       
        this.$emit('phone-input-change', {
          phoneNumber: this.phoneNumber,
          countryName: this.selectedCountry,
          isValid: this.isValid
        })
    },

    onCountryChange(country) {
      if (country) {
        this.currentDialCode = country.dialCode.replace('+', '');
        this.selectedCountry = country.iso2;
        this.countryName = country.name;
        this.phoneNumber = `+${country.dialCode}`;
        this.$emit('phone-input-change', {
          phoneNumber: this.phoneNumber,
          countryName: this.selectedCountry,
          isValid: true
        });
      }
    },

    onInput(event) {
      const formattedNumber = String(event.target.value);

      const dialCodeRegex = new RegExp(`^\\+${this.currentDialCode}`);
      if (!formattedNumber.match(dialCodeRegex)) {
        this.phoneNumber = `+${this.currentDialCode}`;
      } else {
        const baseNumber = `+${this.currentDialCode}`;
        const extraDigits = formattedNumber.substring(baseNumber.length).replace(/[^\d]/g, '');
        if (extraDigits) {
          this.phoneNumber = `${baseNumber}${extraDigits}`;
        } else {
          this.phoneNumber = baseNumber;
        }
      }
    },

    handleBlur() {
      this.isFocused = false
      this.hasBlurred = true
    },

    async createAccount() {
      if (this.validateEmail() == true && this.validatePhoneNumber() == true) {
        var newUserObj = await this.billingSignupV2({
          name: this.companyName,
          domain: this.domain,
          isPartner: true,
          countryCode: this.selectedCountry,
          // logo: "string",
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.Email,
          plan: 'FreeTrial',
          mobileNo: this.phoneNumber,
          referrer: "PMaps",
          testToDeploy: this.testId
        });
        this.$router.push(`/otp-code-new/${newUserObj.object.data.token}/${btoa(newUserObj.object.data.userId)}/${btoa(newUserObj.object.data.email)}`);
      }
    },

    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,10})+$/;
      const disallowedDomains = ["outlook", "hotmail", "gmail", "yahoo", "aol", "icloud", "rediff", "email", "rediffmail"];
      const email = this.Email.trim().toLowerCase();
      if (!emailRegex.test(email)) {
        return this.ShowWarningMessage("Please enter a valid email addresses");
      }
      else {
        const emailSplit = email.split("@")[1];
        this.domain = emailSplit.split(".")[0];
        if (disallowedDomains.includes(this.domain)) {
          return this.ShowWarningMessage("Emails from " + this.domain + " are not allowed");
        } else {
          return true;
        }

      }

    },


    fetchLocation() {
      fetch("https://ipapi.co/json/")
        .then((response) => response.json())
        .then((data) => {

          const country = this.GetLocationData.object.data.find(item => item.name === data.country_name);
          if (country) {
            this.defaultCountry = country.iso2;
            this.selectedCountry = country.iso2;
            this.countryName = country.name;

            this.currentDialCode = country.phonecode.replace('+', '');

            this.$nextTick(() => {
              this.phoneNumber = `+${this.currentDialCode}`;
            });
          }
        })
    },
    
    renderRecaptcha() {
      if (window.grecaptcha) {
        window.grecaptcha.render('recaptcha-container', {
          sitekey: this.siteKey,
          callback: this.onCaptchaVerified,
          'expired-callback': this.onCaptchaExpired,
          theme: 'light',
          //size: window.innerWidth < 400 ? 'compact' : 'normal'
        })
      } else {
        console.warn('grecaptcha not available yet')
      }
    },

    renderCaptcha() {
    window.grecaptcha.render('recaptcha-container', {
      sitekey: this.siteKey,
      callback: this.handleCaptchaSuccess
    });
  },
  onCaptchaVerified(token) {
      this.captchaToken = token;
      this.captchaVerified=true;
      
      //console.log('CAPTCHA Verified:', token)
    },
    onCaptchaExpired(){
      this.captchaToken = "",
      this.captchaVerified=false;
    }
  },
};
</script>
<style scoped>
.container-fluid{
  background: linear-gradient(to right, #dcd7f5 50%, #ffffff 50%);  padding: 0;
}
.login_left_section_signup {
  position: relative;
  height: 100vh;
  background-color: #dcd7f5;
  overflow: hidden;
}

.image-fill-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.image-fill-container img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* This is key: fill like a background */
  display: block;
}
.login_right_section_signup {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  background-color: white !important;
  justify-content: center;
  margin-top: 0;
}
.btn-primary2 {
  border-radius: 50px !important;
  border: 2px solid #7c68ee !important;
  background: #fff !important;
  color: #7c68ee !important;
  margin: 0px 6px 0 0;
}

.btn-primary2:hover {
  background: #7c68ee !important;
  color: #ffffff !important;
  margin: 0px 6px 0 0;
}



.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: 0rem !important;
  padding-left: 0rem !important;

  margin-right: auto;
  margin-left: auto;
}

.responsive {
  margin-top: 8%;
}

.phone-input-container {
  max-width: 500px;
}

.label-position {
  top: -0.5rem;
  left: 1rem;
  z-index: 1;
}

:deep(.vue-tel-input) {
  border-radius: 8px;
  border: 0.125rem solid #D4D4D4;
  padding: 0 0.7rem;
  transition: all 0.25s ease 0s;
}

:deep(.vti__input) {
  background: transparent !important;
  border: none !important;
  outline: none !important;

  padding: 0.375rem 0.75rem;
}

:deep(.vue-tel-input:focus-within) {
  border-color: #7b68ee !important;
  box-shadow: none !important;
}

.input-name.input-focused {
  top: -18px;
  color: #7b68ee;
}

:deep(.vti__dropdown) {
  padding-left: 0.75rem;
  border: none;
  background: transparent;
  min-width: 60px;
  cursor: pointer !important;
}

:deep(.vti__dropdown-list) {
  z-index: 1000 !important;
  pointer-events: auto !important;
  scrollbar-width: thick !important;
  scrollbar-color: #7b68ee #f1f1f1;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

:deep(.vti__dropdown-item) {
  cursor: pointer !important;
  pointer-events: auto !important;

  &.highlighted {
    background: #f5f5f5 !important;
  }

  strong {
    display: none;
  }

  span {
    margin-left: 8px;
  }
}
@media (max-width: 500px) {
  .responsive {
    margin-top: 25% !important;
  }

  .space {
    margin-top: 4%;
  }
}

@media (max-width: 900px) {
  .responsive {
    margin-top: 30%;
  }
}
</style>